import { create } from 'zustand';

const useUnreadConversationsStore = create<{
	unreadConversationIds: Set<number>;
	addUnreadConversationId: (conversationId: number) => void;
	removeUnreadConversationId: (conversationId: number) => void;
	setUnreadConversationIds: (conversationIds: Set<number> | Array<number>) => void;
}>((set) => ({
	unreadConversationIds: new Set<number>(),
	addUnreadConversationId: (conversationId) =>
		set(({ unreadConversationIds: unreadConversations }) => {
			const updatedSet = new Set(unreadConversations);
			updatedSet.add(conversationId);

			return { unreadConversationIds: updatedSet };
		}),
	removeUnreadConversationId: (conversationId) =>
		set(({ unreadConversationIds: unreadConversations }) => {
			const updatedSet = new Set(unreadConversations);
			updatedSet.delete(conversationId);

			return { unreadConversationIds: updatedSet };
		}),
	setUnreadConversationIds: (conversationIds) =>
		set(() => ({ unreadConversationIds: new Set(conversationIds) })),
}));

export default useUnreadConversationsStore;
